import React from 'react';
import Section from '../common/Section';


/**
 * Clinician credibility panel.
 */
const ClinicianSection = () => (
  <Section id="for-clinicians" background="white" padding="md" panel={false} className="pt-2" style={{ backgroundColor: 'var(--cream-canvas)' }}>
    <div
      className="max-w-6xl mx-auto rounded-[28px] border p-6 sm:p-8 md:p-10"
      style={{
        backgroundColor: 'var(--surface-soft-3)',
        borderColor: 'rgba(31, 42, 36, 0.08)',
        boxShadow: '0 18px 38px rgba(20, 48, 36, 0.08)',
      }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        {/* Placeholder avatar until clinician headshot asset is provided. */}
        <div
          className="h-16 w-16 rounded-full flex items-center justify-center font-extrabold text-lg"
          style={{ backgroundColor: 'var(--brand-green-deep)', color: '#fff' }}
          aria-label="Clinician placeholder avatar"
        >
          RC
        </div>
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold" style={{ color: 'var(--text-primary)' }}>
            Built by a licensed clinician.
          </h2>
          <p className="mt-2 leading-relaxed" style={{ color: 'var(--text-muted)' }}>
            Designed by a Licensed Professional Counselor and 20 year Army veteran, grounded in CBT, DBT, and ACT. Not a replacement for therapy, a companion for the days in between.
          </p>
        </div>
      </div>
    </div>
  </Section>
);

export default ClinicianSection;
